import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import dashboard from './slices/dashboardSlice'
import buat_email from "./slices/buatEmailSlice";

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        dashboard,
        buat_email,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
